export default __webpack_public_path__ + "static/media/favicon.af0e8bd9.ico";